import React, { Fragment } from 'react';

import { Text } from '@krea/common/shared-components/text';
import { useGetOneFieldRequest } from '@krea/common/store/field-requests/hooks/queries';

const PawnedInvoicesForm = ({ fieldRequestID, withInputLabel }) => {
  const { data: { displayName } = {} } = useGetOneFieldRequest(fieldRequestID);
  // This will probably never be show since its designed to be a conditional field request only.
  // And ALWAYS have is_collected_by_lender set to true. Which would render the "FieldRequestCollectedByLender" component
  // So this is basically just a placeholder/fallback component that could be rendered, just in case.

  return (
    <Fragment>
      {withInputLabel && (
        <Fragment>
          <Text
            htmlTag="label"
            size="sm"
            className={'d-inline-block font-weight-bold'}
          >
            {displayName}
          </Text>
        </Fragment>
      )}
    </Fragment>
  );
};

export default PawnedInvoicesForm;
